import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditService } from '../base';
import { SellingCompany } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyService extends TmsWebBaseEditService<SellingCompany, SellingCompany> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SellingCompany', $localize`Selling Company`);
  }

  getCustomsInformation(id: string): Observable<SellingCompany> {
    return this.httpService.get<SellingCompany>(`${this.apiUrl}/GetCustomsInformation?id=${id}`);
  }
}
